class GwpCta extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    const hideUntil = localStorage.getItem('hideGwpCtaUntil')
    if (!hideUntil || new Date().getTime() >= parseInt(hideUntil, 10)) {
      this.setAttribute('active', 'true')
    }

    if (window.innerWidth <= 768) {
      const time = parseInt(this.getAttribute('data-hide-after') || '0', 10)
      if (time > 0) {
        setTimeout(() => {
          this.removeAttribute('active')
        }, time)
      }
    }
  }

  setupListeners () {
    super.setupListeners()

    this.handleClose = this.handleClose.bind(this)
    this.listeners.add(this.els.close.element, 'click', this.handleClose)
  }

  handleClose () {
    const now = Date.now()
    const day = 24 * 60 * 60 * 1000
    localStorage.setItem('hideGwpCtaUntil', now + day)
    this.removeAttribute('active')

    setTimeout(() => {
      this.remove()
    }, 1000)
  }
}

if (!customElements.get('gwp-cta')) {
  customElements.define('gwp-cta', GwpCta)
}
